<div class="c-form__field c-form__field--without-label">
    <input
        class="c-form__submit c-button c-button--primary"
        id="{ id }"
        type="submit"
        value="{ options.label }"
        disabeld="{ isLoading ? 'true' : 'false' }"
    />
</div>